"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlgoliaError = void 0;
const useAlgoliaContext_1 = require("./useAlgoliaContext");
const useAlgoliaError = () => {
    const { error } = (0, useAlgoliaContext_1.useAlgoliaContext)();
    return error;
};
exports.useAlgoliaError = useAlgoliaError;
//# sourceMappingURL=useAlgoliaError.js.map